export const DEFAULT_VARIANTS = [
    'success',
    'warning',
    'error',
    'info',
];
export const TYPOGRAPHY_VARIANTS = [
    'body2',
    'h4',
];
export const DEFAULT_TYPOGRAPHY_VARIANT = 'body2';
//# sourceMappingURL=Alert.constants.js.map